"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var react_2 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var Action_1 = require("./Redux/Action");
var mapDispatchToProps = {
    dispatchChangeBreadcrumb: Action_1.changeBreadCrumbAction
};
var mapStateToProps = function (state) {
    return {
        pageBreadCrumbItems: state.layouHeader.pageBreadcrumbItems,
        maxDisplayedItems: state.layouHeader.maxDisplayedItems,
        overflowIndex: state.layouHeader.overflowIndex
    };
};
var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
var LayoutContentHeaderTitleComponent = function (props) {
    var t = react_i18next_1.useTranslation(['menu']).t;
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var menuEntry = props.menuEntry, pageBreadCrumbItems = props.pageBreadCrumbItems, dispatchChangeBreadcrumb = props.dispatchChangeBreadcrumb, maxDisplayedItems = props.maxDisplayedItems, overflowIndex = props.overflowIndex;
    var renderMultipleTitle = function (titleParts) {
        var items = titleParts.map(function (itemTitle, index) {
            var _a;
            return ({
                key: "title-part-" + index,
                text: t(itemTitle.title),
                onClick: itemTitle.pathname !== '' && ((((_a = location.search) !== null && _a !== void 0 ? _a : '') !== '') || (location.pathname !== itemTitle.pathname)) ? function () { history.push(itemTitle.pathname); dispatchChangeBreadcrumb([]); } : undefined
            });
        });
        var iconName = titleParts.length > 0 ? titleParts[titleParts.length - 1].iconName : '';
        return (react_2.default.createElement(react_2.default.Fragment, null,
            iconName &&
                react_2.default.createElement(react_1.Icon, { iconName: iconName }),
            react_2.default.createElement(react_1.Breadcrumb, { onReduceData: function () { return undefined; }, items: __spreadArrays(items, pageBreadCrumbItems !== null && pageBreadCrumbItems !== void 0 ? pageBreadCrumbItems : []), maxDisplayedItems: maxDisplayedItems, overflowIndex: overflowIndex })));
    };
    return (react_2.default.createElement("div", { className: "layout-content-header-title" }, renderMultipleTitle(menuEntry !== null && menuEntry !== void 0 ? menuEntry : [])));
};
exports.LayoutContentHeaderTitle = connector(LayoutContentHeaderTitleComponent);
//# sourceMappingURL=LayoutContentHeaderTitle.js.map